const awsConfiguration = {
  region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_7IN4ai6Nl",
  ClientId: "4rrm7h6gkqqenhjluu91l0b9po"
}
export default awsConfiguration
